export default {
  namespaced: true,
  state: {
    // 最后一次选择的appID
    lastSearchAppID: 0
  },
  mutations: {
    setLastSearchAppID: function setLastSearchAppID(state, appID) {
      console.log("setLastSearchAppID->the appID is:" + appID);
      state.lastSearchAppID = appID;
    }
  }
};